import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import appStore from '@/store/app';
import bannersStore from '@/store/banners';
import { Banner as Model } from '@/models';
import CardComponent from '@/components/CardComponent';
import EditToolbar from '@/components/EditToolbar';
import { Guid, BannerPosition, SelectItem } from '@/types';

@Component({
   components: { CardComponent, EditToolbar },
})
export default class Banner extends Vue {

   // Injectectd from url
   @Prop({ default: '' }) private readonly id!: string;

   private total = 0;
   private selectedBannerFile: File | null = null;

   get banner(): Model {
      const result = bannersStore.banner;
      result.publishingDate = new Date(result.publishingDate);
      result.expiryDate = new Date(result.expiryDate);
      return result;
   }

   get positions(): SelectItem<string>[] {
      return bannersStore.positions;
  }

   get loading(): boolean {
      return appStore.isLoading;
   }

   get isNewBanner(): boolean {
      return this.id === Guid.Empty;
   }

   private async created() {
      await bannersStore.fetchBannerAsync({id: this.id});
   }

   private async mounted() {
      await appStore.activateMenuById({ rootId: 500, subMenuId: 501 });
   }

   @Watch('selectedBannerFile', { immediate: false, deep: false })
   private async onDocumentUploaded(image: File, previousValue?: File) {
      if (image) {
         await this.uploadFileAsync(image);
      }
   }

   private async save() {

      if (!this.banner.fileName) {
         appStore.error({ message: 'Pubblicare un\'immagine per il banner.'});
         return;
      }

      this.$buefy.dialog.confirm({
         title: 'Aggiornamento banner',
         message: 'Sei sicuro/a di voler apportare le modifiche al banner selezionato ?',
         confirmText: 'Conferma',
         cancelText: 'Annulla',
         type: 'is-info',
         hasIcon: true,
         onConfirm: async () => {
            await this.saveAsync();
         },
      });
   }

   private async saveAsync() {

      const bannerToSave = this.banner;

      if (!bannerToSave) return;

      await bannersStore.upsertBannerAsync(
         {
            id: bannerToSave.id || Guid.Empty,
            name: bannerToSave.name,
            position: bannerToSave.position,
            publishingDate: bannerToSave.publishingDate,
            expiryDate: bannerToSave.expiryDate,
            fileName: bannerToSave.fileName,
            originalFileName: bannerToSave.originalFileName,
            hyperLink: bannerToSave.hyperLink,
         })
         .then((result) => {
            if (result) {
               this.$router.go(-1);
            }
         });
   }

   private cancel(): void {
      this.$router.go(-1);
   }

   private removeBanner() {
      this.banner.url = '';
      this.banner.fileName = '';
      this.banner.originalFileName = '';
      this.selectedBannerFile = null;
   }

   private async uploadFileAsync(image: File) {
      await bannersStore.uploadBannerAsync({ file: image })
                        .then((result) => {
                              if (result) {
                                 this.banner.fileName = result.fileName;
                                 this.banner.originalFileName = result.originalFileName;
                                 this.banner.url = `${result.url}`;
                              }
                        });
   }

   private getImageUrl(banner: Model) {
      if (banner.url) {
         return `${banner.url}?height=100&mode=crop`;
      }
      return '';
   }

}
